import {Routes} from '@angular/router';

export const afterserviceManagementRoutes: Routes = [
  {
    path: 'afterServiceManagement',
    data: { title: '退货管理' },
    children: [
      {
        path: '',
        loadComponent: () => import('./afterservice-management.component').then(m => m.AfterserviceManagementComponent),
        data: { title: '售后管理' },
      },
      {
        path: 'afterServiceDetail',
        loadComponent: () => import('./afterservice-detail/returngoods-detail.component').then(m => m.ReturngoodsDetailComponent),
        data: { title: '售后明细' },
      },
      {
        path: 'afterServiceDetail/:afterServiceOrderId',
        loadComponent: () => import('./afterservice-detail/returngoods-detail.component').then(m => m.ReturngoodsDetailComponent),
        data: { title: '售后明细' },
      },
    ]
  },
];
